import { FilterActions } from '../constants/filter/filter_actions';
import Dispatcher from '../dispatcher';

function enableOptionAction(payload) {
    Dispatcher.handleCatalogConditionalOptionsAction({
        type: FilterActions.ENABLE_OPTION,
        payload
    });
}

function disableOptionAction(payload) {
    Dispatcher.handleCatalogConditionalOptionsAction({
        type: FilterActions.DISABLE_OPTION,
        payload
    });
}

export {
    enableOptionAction,
    disableOptionAction
};